import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { getConsumptionDetailsInitiate } from '../../../actions/company';
import Consumptions from './Consumptions';
import { currentFlowTypeEnum } from '../../common/components/constants';
import { getEmployeeConsumptionsInitiate } from '../../../actions/employee';
import { openErrorToast, openSuccessToast } from '../../../reducers/uiLogic';

const mapStateToProps = state => {
  const ordersResponse = _get(state, 'company.ordersData', []);
  const employeeOrdersData = _get(state, 'employees.ordersData', []);
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    ordersResponse,
    employeeOrdersData,
    selectedWorkspace,
    fetchingOrders:
      _get(state, 'apiState.GET_CONSUMPTION_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_CONSUMPTION_DETAILS.isIdle', false),
    fetchedOrders: _get(
      state,
      'apiState.GET_CONSUMPTION_DETAILS.success',
      true,
    ),
    fetchingEmployeeOrders:
      _get(state, 'apiState.GET_EMPLOYEE_CONSUMPTIONS.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEE_CONSUMPTIONS.isIdle', false),
    fetchedEmployeeOrders: _get(
      state,
      'apiState.GET_EMPLOYEE_CONSUMPTIONS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getConsumptions: payload => dispatch(getConsumptionDetailsInitiate(payload)),
  getEmployeeConsumptions: payload =>
    dispatch(getEmployeeConsumptionsInitiate(payload)),
  showSuccessToast: message => dispatch(openSuccessToast(message)),
  showErrorToast: message => dispatch(openErrorToast(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Consumptions);
